<template>
  <div>
    <el-menu
      style="width: 200px; min-height: calc(100vh - 50px)"
      :default-active="path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      router
      background-color="rgb(153, 153, 153)"
      text-color="#fff"
      active-text-color="black"
    >
      <el-menu-item index="/dashboard">
        <span class="iconfont icon-shujuzhanshi"></span>&nbsp;
        <span>展示板</span>
      </el-menu-item>
      <el-sub-menu index="2" text-color="#fff">
        <template #title>
          <span class="iconfont icon-gerenxinxi"></span>&nbsp;
          <span>个人信息</span>
        </template>
        <el-menu-item index="/person">
          <span class="iconfont icon-xiugai"></span>&nbsp;
          <span>修改个人信息</span>
        </el-menu-item>
        <el-menu-item index="/password">
          <span class="iconfont icon-mima"></span>&nbsp;

          <span>修改密码</span>
        </el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/user" v-if="user.role == 1">
        <span class="iconfont icon-duzhe"></span>&nbsp;

        <span>读者管理</span>
      </el-menu-item>
      <el-menu-item index="/book" v-if="user.role == 1">
        <span class="iconfont icon-tushuguan"></span>&nbsp;

        <span>书籍管理</span>
      </el-menu-item>
      <el-menu-item index="/book" v-if="user.role == 2">
        <span class="iconfont icon-tushuguan"></span>&nbsp;

        <span>图书查询</span>
      </el-menu-item>
      <el-menu-item index="/lendrecord" v-if="user.role == 1">
        <span class="iconfont icon-shiwujieyue"></span>&nbsp;

        <span>借阅管理</span>
      </el-menu-item>
      <el-menu-item index="/lendrecord" v-if="user.role == 2">
        <span class="iconfont icon-shiwujieyue"></span>&nbsp;

        <span>借阅信息</span>
      </el-menu-item>
      <el-menu-item index="/bookwithuser">
        <span class="iconfont icon-wodejieyue"></span>&nbsp;
        <span>借阅状态</span>
      </el-menu-item>
      <el-menu-item index="/book-cover-recognition" v-if="user.role == 1">
        <span class="iconfont icon-OCRshibie"></span>&nbsp;
        <span>书籍封面识别</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Aside",
  components: {},
  created() {
    let userStr = sessionStorage.getItem("user") || "{}";
    this.user = JSON.parse(userStr);
  },
  data() {
    return {
      user: {},
      path: this.$route.path,
    };
  },
};
</script>

<style scoped>
.icon {
  width: 30px;
  height: 30px;
  padding-top: 5px;
  padding-right: 10px;
}
</style>